import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React from 'react';
import { useSelector } from 'store';
import { GetAllBranchesNewsAPI, GetBranchNewsAPI } from 'api/community';
import { ERROR_500 } from 'constants/message';
import { useDispatch } from 'react-redux';
import { communityActions } from 'store/community';

var ClusterMenuFeed = function ClusterMenuFeed(_ref) {
  var selected = _ref.selected,
      callback = _ref.callback;
  var regions = useSelector(function (state) {
    return state.space.regions;
  }).results;
  var dispatch = useDispatch();

  var clickMenu = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var cluster, default_count, response, region_id, value;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cluster = event.target.text;
              clearMenu(cluster);
              default_count = 10;
              response = null;

              if (!(cluster === '전체')) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return GetAllBranchesNewsAPI(default_count);

            case 7:
              response = _context.sent;
              _context.next = 14;
              break;

            case 10:
              region_id = findClusterID(cluster);
              _context.next = 13;
              return GetBranchNewsAPI(region_id, default_count);

            case 13:
              response = _context.sent;

            case 14:
              if (!(response.status >= 400)) {
                _context.next = 17;
                break;
              }

              alert(ERROR_500);
              return _context.abrupt("return");

            case 17:
              dispatch(communityActions.setBranchNews(response.data));

              if (callback !== null) {
                value = cluster === '전체' ? 'ALL' : findClusterID(cluster).toString();
                callback(value);
              }

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clickMenu(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var clearMenu = function clearMenu(cluster) {
    var menu = document.getElementById('clusterMenu');
    menu.querySelectorAll('li').forEach(function (element) {
      var aTag = element.firstElementChild;

      if (aTag.textContent === cluster) {
        element.className = 'selected';
      } else {
        element.classList.remove('selected');
      }
    });
  };

  var findClusterID = function findClusterID(cluster) {
    return regions.filter(function (region) {
      if (region.name === cluster) return region;
    })[0].id;
  };

  return /*#__PURE__*/_jsx("div", {
    className: "s-menu",
    id: "clusterMenu",
    children: /*#__PURE__*/_jsxs("ul", {
      children: [selected === 'ALL' ? /*#__PURE__*/_jsx("li", {
        className: "selected",
        children: /*#__PURE__*/_jsx("a", {
          onClick: clickMenu,
          children: "\uC804\uCCB4"
        })
      }) : /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx("a", {
          onClick: clickMenu,
          children: "\uC804\uCCB4"
        })
      }), regions.map(function (region) {
        if (region.name === selected) {
          return /*#__PURE__*/_jsx("li", {
            className: "selected",
            children: /*#__PURE__*/_jsx("a", {
              onClick: clickMenu,
              children: region.name
            })
          }, region.id);
        }

        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx("a", {
            onClick: clickMenu,
            children: region.name
          })
        }, region.id);
      })]
    })
  });
};

export default ClusterMenuFeed;